import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useForm, Form } from "../form/useForm";
import Input from "../controls/Input";
import Select from "../../components/controls/Select";
import { Box } from "@mui/material";

import useStyles from "./addAdminDialogStyle";
import { useTranslation } from "react-i18next";

import Button from "../controls/Button";


import globalStyles from "../../style/global.js";
import DatePickerView from "../controls/DatePicker";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import CircularProgressBar from "../circularProgress/CircularProgress";

import ShowAlerts from "../alert/Alert";
import { addNewAdminData } from '../../redux/reduser/addNewAdmin';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function AddAdminDialog(props) {
    const classes = useStyles();
  const globalClasses = globalStyles();

  const { t } = useTranslation();
  const { response, loading, error, errorMsg } = useSelector(
    (state) => state.addNewAdmin
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const initialFValues = {
    userName: "",
    

    email: "",
    phone: "",
    password: "",

    confirmPassword: "",
    roles: "",
   
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("userName" in fieldValues)
      temp.userName = fieldValues.userName ? "" : t("required");

    if ("phone" in fieldValues)
      temp.phone = fieldValues.phone
        ? (temp.phone =
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(
              fieldValues.phone
            )
              ? ""
              : t("invalidPhoneNumber"))
        : t("required");
   
 
    if ("password" in fieldValues)
      temp.password = fieldValues.password
        ?  ""
         
        : t("required");

     if ("confirmPassword" in fieldValues)
      temp.confirmPassword = fieldValues.confirmPassword
        ?  (fieldValues.confirmPassword===fieldValues.password)
        ?  ""
          : t("passwordDoesNotMatch")
          : t("required");
      //  if ("confirmPassword" in fieldValues)
      //     temp.confirmPassword =  fieldValues.confirmPassword==fieldValues.password
      //       ?  ""
      //         : t("passwordDoesNotMatch");

    if ("email" in fieldValues)
      temp.email = fieldValues.email
        ? (temp.email = /$^|.+@.+..+/.test(fieldValues.email)
            ? ""
            : t("invalidEmailAddress"))
        : t("required");
        
        if ("roles" in fieldValues)
        temp.roles = fieldValues.roles ? "" : t("required");
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
   
    if (validate()) {
      dispatch(addNewAdminData(values))
        .unwrap()
        .then(() => {
          if (!error) {
            resetForm();
            setOpen(true);
          } else {
            setOpen(true);
            
          }
        })
        .catch(() => {
          setOpen(true);
          
        });
    }
  };


    return (
        <div>
         
          <Dialog
            open={props.open}
            onClose={props.handleClose}
            TransitionComponent={Transition}
            keepMounted
            // fullWidth={true}
            maxWidth={"50%"} 
          
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>  {props.title}</DialogTitle>
            <DialogContent>
            <div >
    
      <ShowAlerts
        open={open}
        handleClose={handleClose}
        type={error ? "error" : "success"}
        msg={error ? errorMsg : response.toString()}
      />
      {loading ? (
        <div className={globalClasses.center}>
          <CircularProgressBar />
        </div>
      ) : null}
      <Form className={globalClasses.form}>
        <Box className={classes.box}>
          <Input
            name="userName"
            label={t("userName")}
            value={values.userName}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.userName}
          />
        </Box>
        <Box className={classes.box}>
                <Select
                  name="roles"
                  label={t("roles")}
                  className={globalClasses.filed}
                  value={values.roles}
                  onChange={handleInputChange}
                  options={[t("admin"), t("subAdmin")]}
                  error={errors.roles}
                />
              </Box>
        <Box className={classes.box}>
          <Input
            name="password"
            label={t("password")}
            type={"password"}
            value={values.password}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.password}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            name="confirmPassword"
            label={t("confirmPassword")}
            type={"password"}
            value={values.confirmPassword}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.confirmPassword}
          />
        </Box>
       
        <Box className={classes.box}>
          <Input
            name="email"
            label={t("email")}
            value={values.email}
            type={"email"}
            className={globalClasses.filed}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Box>
        <Box className={classes.box}>
          <Input
            name="phone"
            className={globalClasses.filed}
            label={t("phone")}
            type={"phone"}
            value={values.phone}
            onChange={handleInputChange}
            error={errors.phone}
          />
        </Box>

    
        <Box>
          <Button
            className={globalClasses.btn}
            text={props.close} 
            className={globalClasses.btn} 
              onClick={props.handleClose}
          
            color="primary"
            disabled={loading}
        
          />
        </Box>
        <Box>
          <Button
            className={globalClasses.btn}
            
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={handleSubmit}
            type="submit"
            text={t("add")}
          />
        </Box>

      
      </Form>
    </div>
            </DialogContent>
            {/* <DialogActions>
              
              < Button text={props.close} 
                 className={globalClasses.btn} 
              onClick={props.handleClose}/>
            </DialogActions> */}
          </Dialog>
        </div>
      );
}

export default AddAdminDialog
